import { SerializedSmartLink } from 'fym-common/src/db/serializersTypes';
import { useCallback, useEffect, useMemo } from 'react';
import { useSendMessageToPreview } from './useSendMessageToPreview';
import { PostMessagableWindow, SMLAppMessages } from './types';

export const useSendSmartLinkUpdateToPreview = (childWindow: PostMessagableWindow, smartLink?: SerializedSmartLink) => {
  // Every hook runs on every render. A link that is not loaded yet only makes
  // `update` a no-op and the return value `undefined`; it never skips a hook.
  const editUrl = smartLink?.recentSmartLinkVersion.editUrl;
  const domain = useMemo(() => (editUrl ? new URL(editUrl).origin : ''), [editUrl]);
  const sendMessageToPreview = useSendMessageToPreview(domain);

  const update = useCallback(() => {
    if (smartLink === undefined) {
      return;
    }
    sendMessageToPreview(childWindow, {
      type: SMLAppMessages.smartLinkUpdate,
      data: { smartLink },
    });
  }, [childWindow, sendMessageToPreview, smartLink]);
  useEffect(() => {
    update();
  }, [update]);

  return smartLink === undefined ? undefined : update;
};
